import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ProjectService } from 'src/app/shared/project/project.service';
import { ImportErrorDesc } from '../import-error-desc';
import { DataService } from 'src/app/shared/network/data.service';
import { ImportStep } from 'src/app/shared/import/import-step';
import { ImportProgressService } from 'src/app/shared/import/import-progress.service';

@Component({
  templateUrl: './data-sanity.component.html',
  styleUrls: ['../general.scss']
})
export class DataSanityComponent implements OnInit {
    projectId: string;

    columnNames: string [];
    columnUniqueValsCounts: number[];
    blockingIssues: ImportErrorDesc[];
    standaloneWarnings: ImportErrorDesc[];
    columnWarnings: ImportErrorDesc[][];

    loading = false;
    dataLoaded = false;
    
    constructor(private projectService: ProjectService, private activatedRoute: ActivatedRoute,
        private router: Router, private dataService: DataService, private importProgressService: ImportProgressService) { }

    ngOnInit(): void {
        this.activatedRoute.queryParams.subscribe((queryParams: any) => {
            let projectId = queryParams.projectId;
            if(projectId) {
                this.projectId = projectId;
                this.projectService.getDataSanityCheckResult(projectId)
                    .then((dataSanityCheckResult: any) => {
                        if ((!dataSanityCheckResult.blockingIssues || !dataSanityCheckResult.blockingIssues.length)
                        && (!dataSanityCheckResult.warnings || !dataSanityCheckResult.warnings.standaloneWarnings || !dataSanityCheckResult.warnings.standaloneWarnings.length)) {
                            let hasWarn = false;
                            for (let i = 0; i < dataSanityCheckResult.warnings.columnWarnings.length; ++i) {
                                if (dataSanityCheckResult.warnings.columnWarnings[i].length) {
                                    hasWarn = true;
                                    break;
                                }
                            }
                            if (!hasWarn) {
                                this.importProgressService.setImportStep(ImportStep.controlColumn);
                                this.router.navigateByUrl('/select-column-control?projectId=' + this.projectId);
                            }
                        }

                        this.blockingIssues = dataSanityCheckResult.blockingIssues;
                        this.columnNames = dataSanityCheckResult.columnNames;
                        this.columnUniqueValsCounts = dataSanityCheckResult.columnUniqueValsCounts;
                        if (dataSanityCheckResult.warnings){
                            this.standaloneWarnings = dataSanityCheckResult.warnings.standaloneWarnings;
                            this.columnWarnings = dataSanityCheckResult.warnings.columnWarnings;
                        }
                        this.dataLoaded = true;
                });
            }
        });
    }

    async save() {
        if(this.loading || !this.dataLoaded) {
            return;
        }
        try{
            this.loading = true;
            await this.dataService.post('import/applyAutoFixes', {
                projectId: this.projectId
            });
            this.importProgressService.setImportStep(ImportStep.controlColumn);
            this.router.navigateByUrl('/select-column-control?projectId=' + this.projectId);
        }finally {
            this.loading = false;
        }
    }
}
